import React from 'react';
import {Box, FormControlLabel, Checkbox} from '@mui/material';
import { LegalQuestion } from 'crqlar-react-common/dist/models/forms/form';
import MdEditor from 'crqlar-react-common/dist/components/MdEditor';
import EditableTypography from 'crqlar-react-common/dist/components/EditableTypography';
import {useTranslation} from 'react-i18next';

interface LegalEditorProps {
    question: LegalQuestion;
    onQuestionUpdate: (question: LegalQuestion) => void;
}

const LegalEditor: React.FC<LegalEditorProps> = ({
                                                     question,
                                                     onQuestionUpdate
                                                 }) => {
    const {t} = useTranslation();
    // Handle title update
    const handleTitleUpdate = (title: string) => {
        onQuestionUpdate({
            ...question,
            title
        });
    };

    // Handle description update
    const handleDescriptionUpdate = (description?: string) => {
        onQuestionUpdate({
            ...question,
            description: description || ''
        });
    };

    // Handle terms text update
    const handleTermsUpdate = (termsText?: string) => {
        onQuestionUpdate({
            ...question,
            termsText: termsText || ''
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                p: 2,
            }}
        >
            {/* Title */}
            <EditableTypography
                value={question.title}
                onChange={handleTitleUpdate}
                multiline
                variant="h6"
                sx={{
                    mb: 2,
                    width: '100%',
                    fontWeight: 'medium',
                    textAlign: 'left',
                    padding: '8px',
                    borderRadius: 1,
                }}
                placeholder={t('Legal agreement')}
            />

            {/* Description */}
            <Box sx={{mb: 3, width: '100%'}}>
                <MdEditor
                    value={question.description || ''}
                    onChange={handleDescriptionUpdate}
                    placeholder={t('Question description (optional)')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Terms Text Area */}
            <Box sx={{mb: 2}}>
                <MdEditor
                    value={question.termsText || ''}
                    onChange={handleTermsUpdate}
                    placeholder={t('Enter terms and conditions text here...')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Checkbox */}
            <FormControlLabel
                control={<Checkbox disabled />}
                label={t('I agree to the terms and conditions')}
            />
        </Box>
    );
};

export default LegalEditor;
